import { Pipe, PipeTransform } from '@angular/core';
import { Event } from '../interfaces/event'
import { DbService } from '../services/db.service';

@Pipe({
  name: 'bokningsbart'
})
export class BokningsbartPipe implements PipeTransform {

  constructor(public db: DbService) {}

  transform(event: Event): string {

    let ret = ''

    let start = event.start
    if (event.allowedStarts && event.allowedStarts.length) start = event.allowedStarts.sort(this.db.sortSortOrder)[0].start

    let end = event.start + event.prebooking - event.duration
    if (event.allowedStarts && event.allowedStarts.length) end = event.allowedStarts.sort(this.db.sortSortOrder)[event.allowedStarts.length - 1].start

    if (event.eventType == 2) ret = 'bokningsbart '

    ret += 'kl ' + this.db.minToTime(start)

    if (event.eventType == 2 && end > start) ret += ' - ' + this.db.minToTime(end)
    
    return ret

  }

}
